import React from "react";
import { useTranslation } from "react-i18next";
import PasswordGate from "components/PasswordGate/PasswordGate.js";
import ResourcesPage from "./ResourcesPage.js";
import { RESOURCES_PUBLISHED } from "./resources-config";

// Mirrors views/Services/GatedService.js: the page does not know it is gated,
// and the gate does not know what it covers. Once RESOURCES_PUBLISHED is true
// this renders straight through and the wrapper can be deleted along with the
// flag, or kept for the next page that needs holding back.
function GatedResources() {
  const { t } = useTranslation();
  const page = <ResourcesPage />;

  if (RESOURCES_PUBLISHED) return page;

  return (
    <PasswordGate
      gateId="resources"
      secret="secret"
      title={t("gate.title")}
      prompt={t("gate.prompt")}
      label={t("gate.label")}
      submitLabel={t("gate.submit")}
      errorText={t("gate.error")}
    >
      {page}
    </PasswordGate>
  );
}

export default GatedResources;
